import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { resolution, spacing },
  tints,
  primaryColours,
} = theme

export const PluginTrackerOverlayStyles = styled.div`
  .overlay-title {
    margin-top: ${spacing.s}px;
  }
  .plugin-step-container {
    margin-top: ${spacing.s}px;
    .plugin-step {
      display: flex;
      align-items: baseline;
      margin-bottom: ${spacing.xs}px;
      .step {
        margin-right: ${spacing.s}px;
      }
    }
    .tracker-image {
      margin-bottom: ${spacing.s}px;
      max-width: 280px;
    }
    .text {
      color: ${primaryColours.aubergine.main};
      margin-bottom: ${spacing.s}px;
    }
    .tracker-banner {
      &:not(:last-child) {
        margin-bottom: ${spacing.s}px;
      }
      padding-right: 24px;
    }
    &:not(:last-child) {
      border-bottom: 1px solid ${tints.darkAubergine};
    }
  }
  @media (min-width: ${resolution.tablet.width}px) {
    .plugin-step-container {
      margin-top: ${spacing.base}px;
      .tracker-image {
        margin-bottom: ${spacing.base}px;
        max-width: 492px;
      }
      .text {
        margin-bottom: ${spacing.base}px;
      }
      &:not(:last-child) {
        border-bottom: 2px solid ${tints.darkAubergine};
      }
    }
  }
  @media (min-width: ${resolution.desktop.width}px) {
    .plugin-step-container {
      margin-top: ${spacing.md}px;
      .plugin-step {
        margin-bottom: ${spacing.s}px;
      }
      .tracker-image {
        margin-bottom: ${spacing.md}px;
        max-width: 600px;
      }
      .text {
        margin-bottom: ${spacing.md}px;
      }
    }
  }
`
